import { LILAC_400, checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getUpsellTitleStyles = () => {
  return StyleSheet.create({
    container: {
      backgroundColor: LILAC_400,
      paddingVertical: checkIsPlatform('web') ? tokens.spacing.SPACING_20 : tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_12,
      flex: 1
    },
    titleWithDetailText: {
      marginTop: tokens.spacing.SPACING_8
    },
    priceDetailsSpacing: {
      marginTop: tokens.spacing.SPACING_20
    }
  });
};